import React from 'react'
import { AppCrudTable } from "@components"
import { useManageAdminStatusMultiple, useTable } from "Pages/Admin/GlobalExecution/Reports/@hooks"
import { Skeleton } from "@mui/material"
import { executionDateColumn, progressBarColumn, reportNameColumn, runtimeColumn, sitesNameColumn, userNameColumn } from "./@columns"
import GlobalExecutionToolbarSelect from "Pages/Admin/GlobalExecution/Reports/Table/Toolbar"


export default function GlobalExecutionTable() {

	const { isTableLoading, tableReportData } = useTable()

	useManageAdminStatusMultiple()

	if (isTableLoading) return <Skeleton variant="rectangular" height={500}/>

	return <AppCrudTable
		title="Global Executions"
		columns={[reportNameColumn(), userNameColumn(), ...sitesNameColumn(), executionDateColumn(), runtimeColumn(), ...progressBarColumn()]}
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <GlobalExecutionToolbarSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>
		}}
		data={tableReportData}
	/>
}